export type AdGroup = {
  adGroupId: string;
  brandgenAdvertiserId: string;
  brandgenCampaignId: string;
  createdBy: string;
  name: string;
  description: string;
  adGroupType: AdGroupType;
  createdAt: string;
  updatedAt: string;
};

export type AdGroupTemplate = {
  id: string;
  brandgenAdvertiserId: string;
  createdBy: string;
  name: string;
  description: string;
  adGroupType: AdGroupType;
  createdAt: string;
  updatedAt: string;
};

export type CreativeAsset = {
  adGroupId: string;
  beeswaxCreativeId: number;
  bgCreativeId: string;
  brandgenAdvertiserId: string;
  click_url: string;
  creativeSrc: string;
  creativeType: string;
  name: string;
  description: string;
  height: number;
  width: number;
  createdAt: string;
  duration: number | null;
  creativeReports: any[];
};

export type CreativeAssetsByAdGroup = {
  adGroupId: string;
  creatives: CreativeAsset[];
};

export type AdGroupCreationBody = {
  adGroupId: string;
  brandgenAdvertiserId: string;
  brandgenCampaignId: string;
  createdBy: string;
  name: string;
  description: string;
  adGroupType: AdGroupType;
};

export type AdGroupTemplateCreationBody = {
  id: string;
  brandgenAdvertiserId: string;
  createdBy: string;
  name: string;
  description: string;
  adGroupType: AdGroupType;
};

export type CreativeTemplateAsset = {
  id: string;
  adGroupTemplateId: string;
  creativeTemplateSrc: string;
  creativeType: string;
  name: string;
  description: string;
  height: number;
  width: number;
  createdAt: string;
  updatedAt: string;
  size_in_bytes: number;
  duration: number | null;
};

export enum AdGroupType {
  IMAGE = "image",
  VIDEO = "video",
}
